module.exports = __webpack_public_path__ + "static/theNOIS-scrn-f72bc772fcc13d50d488a3ad2243af87.png";